module.exports = __webpack_public_path__ + "static/img/pro-img1.41caf20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pro-img1.jpg
// module id = IMBh
// module chunks = 0